import usersStore from '@/stores/UsersStore'
import consultasStore from '@/stores/ConsultasStore'
import rdiStore from '@/stores/RdiStore'
import adicionalesStore from '@/stores/AdicionalesStore'
import entregaStore from '@/stores/EntregaStore'
import fileManagerStore from '@/stores/FileManagerStore'
import forgeStore from '@/stores/ForgeStore'
import meetingStore from '@/stores/MeetingsStore'
import notificationsStore from '@/stores/NotificationsStore'
import interactionsStore from '@/stores/InteractionsStore'
import kanbanStore from '@/stores/KanbanStore'

const projectStores = [
  usersStore,
  consultasStore,
  rdiStore,
  adicionalesStore,
  entregaStore,
  fileManagerStore,
  forgeStore,
  meetingStore,
  notificationsStore,
  interactionsStore,
  kanbanStore,
]

export function resetProjectData() {
  projectStores.forEach(store => store.commit('resetForProject'))
}
